import modalMixin from '../../mixins/_modal';

/**
 * ストアテンプレートの変更最終確認モーダル
 */
export default {
    name: 'modalStoreTemplateChangeConfirm',
    template: '#modal_store_template_change_confirm',
    data() {
        return {
            // 既存パーツを残すかどうか
            is_take_over: true
        };
    },
    mixins: [
        modalMixin,
    ],
    emits: ['store-template-change-confirm'],
    methods: {
        // 「テンプレートの内容で更新する」押下時
        emitStoreTemplateChangeConfirm: function(){
            this.$emit('store-template-change-confirm', this.is_take_over);
            this.close();
        },
    }
}; 